
import { isObject, isPlainObject } from '../miscellaneous/objectHelpers';
import { localStorageHyperDashboardTools } from './localStorageHyperDashboardTools';

const printInConsole = (type, isMockTypeCorrect) => {
    if(localStorageHyperDashboardTools.getValueByPropName('isPreventerConsoleShown', false)) {
        console.log(`%cNot an ${type} has been passed to == preventerTools ==`, 'background-color: red');
        !isMockTypeCorrect && console.log(`%cNot an ${type} has been provided as mock to == preventerTools ==`, 'background-color: red');
    }
};

const provideObject = (value, mock = undefined, isShallowCheck = undefined) => {

    const checkIfTypeCorrect = value => isShallowCheck ? isObject(value) : isPlainObject(value);

    if(!checkIfTypeCorrect(value)) {
        const isMockTypeProvidedAndCorrect = mock ? checkIfTypeCorrect(mock) : false;
        printInConsole('object', mock ? isMockTypeProvidedAndCorrect : true);
        return mock && isMockTypeProvidedAndCorrect ? mock : {};
    } else {
        return value;
    }
};

const provideArray = (value, mock = undefined) => {
    if(!Array.isArray(value)) {
        const isMockTypeCorrect = mock ? Array.isArray(mock) : false;
        printInConsole('array', mock ? isMockTypeCorrect : true);
        return mock && isMockTypeCorrect ? mock: [];
    } else {
        return value;
    }
};

export const preventerTools = {
    provideObject,
    provideArray
};
